import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

const VerifyAccount = props => {
  useEffect(() => {
    // TODO show loading status when verification...

    const verify = async () => {
      try {
        const response = await axios.post('/api/v1/auth/verifyAccount', { token: props.match.params.token });

        if (response.data.success) {
          props.history.push('/my');
        } else {
          props.history.push('/');
        }
      } catch (e) {
        props.history.push('/');
      }
    };
    verify();
  }, []);

  return (
    <div>
      <h1>Verify account</h1>
      <h1>{props.match.params.token}</h1>
    </div>
  );
};

VerifyAccount.propTypes = {
  match: PropTypes.object.isRequired, // TODO
  history: PropTypes.object.isRequired, // TODO
};

export default VerifyAccount;
